/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface MembershipTypeExpBase
 */
export interface MembershipTypeExpBaseOptional {
  /**
   *
   * @type {number}
   * @memberof MembershipTypeExpBase
   */
  season?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpBase
   */
  startDate?: Date;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpBase
   */
  expirationDate?: Date;
}

export interface MembershipTypeExpBase extends MembershipTypeExpBaseOptional {
  /**
   *
   * @type {number}
   * @memberof MembershipTypeExpBase
   */
  season?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpBase
   */
  startDate?: Date;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpBase
   */
  expirationDate?: Date;
}

export interface MembershipTypeExpBaseTrackedI {
  /**
   *
   * @type {number}
   * @memberof MembershipTypeExpBase
   */
  season?: number;
  seasonIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpBase
   */
  startDate?: Date;
  startDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeExpBase
   */
  expirationDate?: Date;
  expirationDateIsSet: boolean;
}

transformDatesMap.set(
  "MembershipTypeExpBase",
  function (model: MembershipTypeExpBase) {
    if (typeof model.startDate == "string")
      model.startDate = new Date(model.startDate);
    if (typeof model.expirationDate == "string")
      model.expirationDate = new Date(model.expirationDate);
  },
);

export type MembershipTypeExpBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  season: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  startDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  expirationDate: PropertyMeta<MetaTypeBase<Date>>;
}>;

export var MembershipTypeExpBaseMeta: MembershipTypeExpBaseMetaI =
  {} as MembershipTypeExpBaseMetaI;
MembershipTypeExpBaseMeta = typeMeta("MembershipTypeExpBase", {
  season: propertyMeta("season", false, false, false, MetaTypesBase.number),
  startDate: propertyMeta("startDate", false, false, false, MetaTypesBase.Date),
  expirationDate: propertyMeta(
    "expirationDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
});

const metaI = MembershipTypeExpBaseMeta;

registerMeta(() => {});

export class MembershipTypeExpBaseTracked implements MembershipTypeExpBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  season__I?: number = undefined;
  seasonIsSet: boolean = false;
  set season(v: undefined | number) {
    if (v !== undefined) {
      this.season__I = v;
      this.seasonIsSet = true;
    } else {
      this.season__I = v || undefined;
      this.seasonIsSet = false;
    }
    this.changeTracker = true;
  }
  get season() {
    return this.season__I;
  }
  startDate__I?: Date = undefined;
  startDateIsSet: boolean = false;
  set startDate(v: undefined | Date) {
    if (v !== undefined) {
      this.startDate__I = v;
      this.startDateIsSet = true;
    } else {
      this.startDate__I = v || undefined;
      this.startDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get startDate() {
    return this.startDate__I;
  }
  expirationDate__I?: Date = undefined;
  expirationDateIsSet: boolean = false;
  set expirationDate(v: undefined | Date) {
    if (v !== undefined) {
      this.expirationDate__I = v;
      this.expirationDateIsSet = true;
    } else {
      this.expirationDate__I = v || undefined;
      this.expirationDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get expirationDate() {
    return this.expirationDate__I;
  }
  constructor(config?: MembershipTypeExpBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: MembershipTypeExpBaseOptional,
    options?: AssignOptions,
  ): MembershipTypeExpBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.season && this.seasonApplyFilter(optionsRequired.filter)) {
      this.season = config.season;
      if (optionsRequired.unassign) this.seasonIsSet = false;
      else this.seasonIsSet = true;
    }
    if (config.startDate && this.startDateApplyFilter(optionsRequired.filter)) {
      this.startDate = config.startDate;
      if (optionsRequired.unassign) this.startDateIsSet = false;
      else this.startDateIsSet = true;
    }
    if (
      config.expirationDate &&
      this.expirationDateApplyFilter(optionsRequired.filter)
    ) {
      this.expirationDate = config.expirationDate;
      if (optionsRequired.unassign) this.expirationDateIsSet = false;
      else this.expirationDateIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): MembershipTypeExpBaseTrackedI {
    const cloned = {} as MembershipTypeExpBaseTrackedI;
    if (
      this.seasonIsSetDeep() &&
      this.seasonApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.seasonIsSet = true;
      cloned.season = this.season;
    } else {
      //cloned.seasonIsSet = false
    }
    if (
      this.startDateIsSetDeep() &&
      this.startDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startDateIsSet = true;
      cloned.startDate = this.startDate;
    } else {
      //cloned.startDateIsSet = false
    }
    if (
      this.expirationDateIsSetDeep() &&
      this.expirationDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.expirationDateIsSet = true;
      cloned.expirationDate = this.expirationDate;
    } else {
      //cloned.expirationDateIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): MembershipTypeExpBaseTrackedI {
    if (!this.seasonApplyFilter(filter)) this.seasonIsSet = false;

    if (!this.startDateApplyFilter(filter)) this.startDateIsSet = false;

    if (!this.expirationDateApplyFilter(filter))
      this.expirationDateIsSet = false;

    return this;
  }
  seasonApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeExpBaseMeta.season,
      MembershipTypeExpBaseMeta,
      this.season,
      this,
    );
  }
  seasonIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.seasonIsSet && this.seasonApplyFilter(filter)) return true;

    return false;
  }
  startDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeExpBaseMeta.startDate,
      MembershipTypeExpBaseMeta,
      this.startDate,
      this,
    );
  }
  startDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startDateIsSet && this.startDateApplyFilter(filter)) return true;

    return false;
  }
  expirationDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipTypeExpBaseMeta.expirationDate,
      MembershipTypeExpBaseMeta,
      this.expirationDate,
      this,
    );
  }
  expirationDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.expirationDateIsSet && this.expirationDateApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.seasonIsSetDeep(filter)) return true;
    if (this.startDateIsSetDeep(filter)) return true;
    if (this.expirationDateIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
